/*********************** Custom JS for Boost AI Search & Discovery  ************************/
const isMobile = () => {
  let check = false;
  (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
  return check;
}

const standard_classes = 'inline-flex items-center bg-white justify-center font-brandon h-[22px] text-[10px] leading-[16px] tracking-1/5px font-bold border-green-1 border px-2 py-1 uppercase';

const isCollectionPage = () => {
  return window.location.pathname.includes('/collections');
};
const seoData = boostSDData?.seo_data;

function formRequest(handle) {
  return new Promise((resolve, reject) => {
    var xhr = window.XMLHttpRequest ? new XMLHttpRequest() : new ActiveXObject('Microsoft.XMLHTTP');
    xhr.open('GET', handle + '.json');
    xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.onload = () => resolve(xhr.responseText);
    xhr.onerror = () => reject(xhr.statusText);
    xhr.send();
  });
}

const customize = {
  addDescription: (componentRegistry) => {  
    componentRegistry.useComponentPlugin('Toolbar', {
      name: 'Product List After Render',
      enabled: true,  
      apply: () => ({
        afterRender(element){
          if (!isCollectionPage()) return;
          try {
            let currentUrl = location.href;
            let requestReg = formRequest(currentUrl);
            requestReg.then((res_success) => {
              let res = JSON.parse(res_success);
              if (!document.querySelector('.boost-collection_description')) {
                document.querySelector('.boost-sd__toolbar-inner').insertAdjacentHTML('afterend', `<div class="boost-collection_description">${res.collection.description}</div>`);
              
              }
            });
          } catch (err) {
            console.warn(err);
          }
        }
      })
    })
  },
  addSEO: (componentRegistry) => {
    componentRegistry.useComponentPlugin('Toolbar', {
      name: 'SEO After Render',
      enabled: true,  
      apply: () => ({
        afterRender(element){
          var seo_html = '';
          if (!isCollectionPage()) return;
          try {
            if(seoData.seo_title || seoData.seo_description){
              seo_html = `<div class="seo-container-wrap px-6 sm:px-[60px] md:px-[80px] mx-auto pt-[71px] border-t border-grey-2 mt-[71px] max-w-[1440px] text-center seo--container">`;
              if(seoData.seo_title){
                seo_html += `<h3 class="font-kings text-[26px] leading-[40px] text-grey-1">${seoData.seo_title}</h3>`;
              }
              if(seoData.seo_description){
                seo_html += `<div class="mt-[26px] text-[18px] leading-[24px] text-grey-1 text-center font-brandon">${seoData.seo_description}</div>`;
              }
              seo_html += `</div>`;

              if(!document.querySelector('.seo-container-wrap')){
                document.querySelector('.boost-sd-layout').insertAdjacentHTML('afterend', seo_html);
              }
            }
          } catch (err) {
            console.warn(err);
          }
        }
      })
    })
  },
  updateProductItem: (componentRegistry) => {
    componentRegistry.useComponentPlugin('ProductItem', {
      name: 'Modify Product Item Element',
      enabled: true,
      apply: () => ({
        afterRender(element){
          let productData = element.getParams().props.product;
          let productItem = document.querySelector('.boost-sd__product-item[data-product-id="'+ productData.id +'"]');

          if (!productItem) {
            return;
          }
          var sku = '';
          var promoMessage = '';
          productData.metafields.length > 0 && productData.metafields.forEach(metafield => {
            if (metafield.namespace == 'custom_fields' && metafield.key == 'root_sku') {
              sku = metafield.value;
              return false;
            } else if (metafield.namespace == 'custom_fields' && metafield.key == 'promotion_message') {
              promoMessage = metafield.value;
              return false;
            }
          });
          /* Product Swatch */
          
          const variants = productData.variants;
          const options = productData.options_with_values;
          var variant_html = '';
          if (variants.length > 1) {
              // color html
              var color_option_index = -1;
              var size_option_index = -1;
              for (var i = 0; i < options.length; i++) {
                if (options[i].name == 'color') {
                  color_option_index = i;
                } else if (options[i].name == 'size') {
                  size_option_index = i;
                }
              }
              var selected_option = variants[0].merged_options[0];
              if (color_option_index == 0) {
                selected_option = variants[0].merged_options[0];
              } else if (color_option_index == 1) {
                selected_option = variants[0].merged_options[1];
              } else {
                selected_option = variants[0].merged_options[2];
              }
              var first_variant_option = selected_option;
              var variant_ids = [];
              variant_ids.push(variants[0].id);
              variants.forEach(variant => {
                var selected_option2 = variant.merged_options[0];
                if (color_option_index == 0) {
                  selected_option2 = variant.merged_options[0];
                } else if (color_option_index == 1) {
                  selected_option2 = variant.merged_options[1];
                } else {
                  selected_option2 = variant.merged_options[2];
                }

                if (selected_option2 != first_variant_option) {
                  variant_ids.push(variant.id);
                  first_variant_option = selected_option2;
                }
              });

              var variant_count = 0;

              for(var i = 0; i < variants.length; i++) {
                if (variant_count >= 3) {
                  break;
                }
                var swatch_color = '';
                if (color_option_index != -1) {
                  if (color_option_index == 0) {
                    swatch_color = variants[i].merged_options[0].toLowerCase();
                  } else if (color_option_index == 1) {
                    swatch_color = variants[i].merged_options[1].toLowerCase();
                  } else {
                    swatch_color = variants[i].merged_options[2].toLowerCase();
                  }
                  var stripped_space = swatch_color.replace(' ', '-').replace(':', '-');
                  var stripped_dash = stripped_space.replace('/', '-');
                  var disabled = ``;
                  if (!variants[i].available) {
                    disabled = 'color-swatch-disabled';
                  }
                  if (variant_ids.includes(variants[i].id)) {
                    variant_html += `<a href="/products/${productData.handle}?variant=${variants[i].id}" class="boost-product-variant-single relative hover:shadow-label-hover color--swatch ${stripped_dash} ${disabled}"><span class="hidden">Swatch ${stripped_dash}</span></a>`
                    variant_count += 1;
                  }
                }
              }
              const color_array = [];
              for(var i = 0; i < variants.length; i++) {
                var swatch_color = '';
                if (color_option_index != -1) {
                  if (color_option_index == 0) {
                    swatch_color = variants[i].merged_options[0].toLowerCase();
                  } else if (color_option_index == 1) {
                    swatch_color = variants[i].merged_options[1].toLowerCase();
                  } else {
                    swatch_color = variants[i].merged_options[2].toLowerCase();
                  }
                  color_array.push(swatch_color);
                }
              }
              const uniq_color_array = [...new Set(color_array)];
              // console.log('colors: ', uniq_color_array);

              var remainging_variants = 0;
              if (uniq_color_array.length > 3) {
                remainging_variants = uniq_color_array.length - 3;
              }

              if (remainging_variants > 0) {
                var temp_html = `colors`;
                if (remainging_variants == 1) {
                  temp_html = `color`;
                }
                variant_html += `<div class="boost-pfs-product-remaining-variant-count">+${remainging_variants} ${temp_html}</div>`
              }

              // size html
              if (size_option_index != -1) {
                if (variant_html) {
                  variant_html += '<div class="boost-pfs-product-color-size-options"> | </div>';
                }
                variant_html += `<div class="boost-pfs-product-size-options-wrapper">${productData.options_with_values[size_option_index].values.length} sizes</div>`;
              }
              variant_html = `<div class="boost-pfs-filter-product-swatch-wrapper">${variant_html}</div>`;
            
          }
          if (!productItem.querySelector('.boost-pfs-filter-product-swatch-wrapper')) {
            productItem.querySelector('.boost-sd__product-item-grid-view-layout-image').insertAdjacentHTML('beforeend', variant_html);
          }
          /* Product Badges */
          var badge_count = 0;
          var sale_badge_html = '';
          var other_badge_html = '';
          if(productData.compare_at_price_max > productData.price_max || productData.tags.includes('badge:sale') || productData.tags.includes('badge:clearance')){
            sale_badge_html = `<span class="${standard_classes} text-red-3">Sale</span>`;
            badge_count += 1;
          }
          if(productData.tags.includes('badge:best-seller')){
            other_badge_html = `<span class="${standard_classes} text-green-1">Best Seller</span>`;
            badge_count += 1;
          }
          else if(productData.tags.includes('badge:new')){
            other_badge_html = `<span class="${standard_classes} text-green-1">New</span>`;
            badge_count += 1;
          }
          else if(productData.tags.includes('badge:limited-edition')){
            other_badge_html = `<span class="${standard_classes} text-green-1">Limited Edition</span>`;
            badge_count += 1;
          }
          if (!productItem.querySelector('.boost-sd__product-badges')) {
            let badges_html = '<div class="boost-sd__product-badges">';
              if(badge_count == 2){
                badges_html+= '<div class="flex gap-2 text-[0px]">';
                badges_html+= other_badge_html;
                badges_html+= sale_badge_html; 
                badges_html+= '</div>';
              }
              else if(badge_count == 1){
                if(sale_badge_html){
                  badges_html+= '<div class="text-[0px]">';
                  badges_html+= sale_badge_html;
                  badges_html+= '</div>';
                }
                else{
                  badges_html+= '<div class="text-[0px]">';
                  badges_html+= other_badge_html;
                  badges_html+= '</div>';
                }
              }
              badges_html += '</div>';

            productItem.insertAdjacentHTML('afterbegin', badges_html);
            var sku_html = `<div class="boost-pfs-filter-product-item-sku-inner">#${sku}</div>`;
            productItem.querySelector('.boost-sd__product-price').insertAdjacentHTML('afterend', sku_html);
            var promo_html = `<div class="boost-pfs-filter-product-item-promo-inner">${promoMessage}</div>`;
            productItem.querySelector('.boost-sd__product-price').insertAdjacentHTML('beforeend', promo_html);
          }

          
          var icon_personalize = `
            <?xml version="1.0" encoding="UTF-8"?>
            <svg width="28px" height="20px" viewBox="0 0 28 20" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                <title>Personalize</title>
                <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                    <g transform="translate(-508.000000, -2396.000000)" fill="#2D3D0F">
                        <g transform="translate(508.000000, 2396.000000)">
                            <g transform="translate(8.110721, 2.151611)">
                                <path d="M5.03881306,9.11545726 C4.91057482,9.09824509 4.79480704,9.03197205 4.71642783,8.93127466 C4.63806002,8.83143876 4.6042188,8.70578901 4.62203081,8.58099414 C4.63984053,8.45705856 4.70752296,8.34431573 4.81171625,8.26856631 C5.05038756,8.09471277 5.31844537,7.96045693 5.60519747,7.87437403 C5.87770087,7.7926118 6.16267474,7.75215922 6.4476486,7.75299418 C6.60349282,7.7538822 6.75845249,7.76420907 6.91252076,7.78658578 C7.06569535,7.80724171 7.21796714,7.83908599 7.36847894,7.87953857 C7.66592325,7.96044151 7.95534271,8.07318874 8.22784611,8.21518918 C8.4994604,8.35547765 8.75504776,8.52157997 8.99194083,8.71093151 C9.22347639,8.89511411 9.43453943,9.10166461 9.62155068,9.32889086 C9.77472299,9.51651501 9.91185925,9.71446823 10.0320954,9.92274612 C10.146085,10.1206993 10.2431539,10.3272498 10.3197366,10.5415647 C10.466676,10.9503869 10.5414828,11.3815726 10.540607,11.8144768 C10.540607,12.0141508 10.5263427,12.2129655 10.4969539,12.4091914 C10.4675651,12.6071446 10.4266018,12.8042429 10.3722767,12.9978909 C10.3179538,13.1941212 10.2520542,13.3877647 10.176356,13.5771163 C10.0988796,13.7707664 10.0116047,13.9609751 9.91632308,14.1468674 C9.80322494,14.3654766 9.66876059,14.5737567 9.5138032,14.7665453 C9.35617618,14.9644986 9.18252679,15.1486856 8.99462642,15.3190887 C8.80048855,15.4938038 8.5947739,15.6547393 8.37837615,15.802779 C8.15574089,15.9525351 7.9241962,16.0893842 7.68374666,16.2124605 C7.19395638,16.4629095 6.67386769,16.6574168 6.13597382,16.7908265 C5.86524866,16.8588182 5.59096701,16.9104591 5.31399522,16.9457449 C5.03882446,16.9818923 4.76096354,16.9991066 4.48223631,17.0000315 C4.24089764,17.0008274 3.99866986,16.9853338 3.75822032,16.9560718 C3.51954901,16.9268098 3.28356785,16.8803334 3.05200949,16.8183656 C2.82045113,16.7563978 2.59427308,16.6754948 2.37609709,16.57825 C2.15613374,16.4792734 1.94507982,16.3622231 1.74737635,16.2270882 C1.54433362,16.0885205 1.35643781,15.9318902 1.18454158,15.7597464 C1.00643292,15.5790075 0.847018538,15.3827839 0.708999997,15.1727654 C0.561169236,14.9489983 0.436496591,14.7131792 0.335866621,14.4687452 C0.127480055,13.9626694 0.00547932526,13.4281931 0.00101093511,13.3576214 C-0.013237758,13.0968389 0.124796741,12.9462213 0.310036591,13.0211115 C0.310036591,13.0211115 0.664475681,13.1071768 1.02691684,13.1398825 C1.12042474,13.1484886 1.21304125,13.1519324 1.30655599,13.1476293 C1.38047137,13.1450471 1.45438675,13.1381618 1.52741073,13.1261119 C1.5835141,13.1175058 1.64050888,13.1037352 1.69394262,13.0865208 C1.75449842,13.0667264 1.81149319,13.0417674 1.86670745,13.0116439 C1.91568648,12.9849642 1.96110447,12.9522584 2.00207003,12.9161111 C2.04659663,12.8782429 2.08578168,12.8360696 2.12051201,12.7895932 C2.16325809,12.7310692 2.20155174,12.6690992 2.23272104,12.6045513 C2.25142216,12.5658217 2.26745137,12.5253691 2.27902815,12.4840573 C2.29238545,12.4358601 2.30307311,12.3876629 2.31197797,12.3386043 C2.32088283,12.2800802 2.32800718,12.221554 2.33335101,12.1621685 C2.33958396,12.0933154 2.34492779,12.0236008 2.34938022,11.9547477 C2.35828508,11.8170415 2.37075326,11.6793353 2.38589335,11.5433476 C2.40637499,11.3781002 2.43843569,11.2154306 2.48118177,11.0553609 C2.53105219,10.8685961 2.59962375,10.686132 2.68422451,10.5114104 C2.78396536,10.3065719 2.90329873,10.1120624 3.03955271,9.92788862 C3.11524861,9.82632974 3.23012955,9.75747664 3.35835867,9.73682071 C3.48659691,9.71702627 3.61839162,9.74714977 3.72260086,9.82030592 C3.82857466,9.89346206 3.89981813,10.0044885 3.92030205,10.1284153 C3.94167509,10.2523509 3.91050579,10.3788643 3.83480989,10.4812957 C3.73328852,10.6172811 3.64512445,10.7618638 3.57122047,10.9133407 C3.51155378,11.0364148 3.46435527,11.1629304 3.42873354,11.2946216 C3.39667512,11.4116719 3.37441068,11.5304407 3.35927059,11.6509392 C3.3450219,11.7714332 3.33433424,11.891936 3.32720989,12.0132717 C3.32186606,12.0898716 3.31652451,12.1673308 3.30940016,12.2430758 C3.30227582,12.3239788 3.29247956,12.4048817 3.27912226,12.484932 C3.26487357,12.5709973 3.24706384,12.6562033 3.22212749,12.7396775 C3.19541062,12.830048 3.16157168,12.9186955 3.12060612,13.0038971 C3.06361135,13.1226682 2.9950398,13.2371384 2.91489147,13.3438662 C2.83919557,13.4437021 2.75370341,13.5366549 2.65841499,13.6201379 C2.56490709,13.7010408 2.46338572,13.7724762 2.35385773,13.832721 C2.2425401,13.8946888 2.12498952,13.9454682 2.00208599,13.9850593 C1.90056462,14.0177651 1.79726046,14.0418626 1.69039298,14.059077 C1.61469708,14.0719883 1.5096124,14.0866182 1.37781085,14.1021096 C1.30478687,14.1107157 1.27005426,14.1701012 1.30122356,14.2355128 C1.38137189,14.4059247 1.45885058,14.5479406 1.53542648,14.6632613 C1.63872836,14.8216234 1.75895313,14.9696521 1.89253292,15.1047804 C2.02077116,15.2338805 2.16059073,15.3500737 2.31196885,15.4533424 C2.46158013,15.5557605 2.6209945,15.6444103 2.78751043,15.7192806 C2.95760335,15.795019 3.13392466,15.8578483 3.31471208,15.9060455 C3.49994509,15.9559634 3.69051281,15.9938337 3.88288156,16.0170719 C4.08058275,16.0411716 4.28095585,16.0540807 4.48132667,16.0532192 C4.71641871,16.05236 4.95153354,16.0377278 5.18484734,16.0076043 C5.42262953,15.9766215 5.65861069,15.9318659 5.89105817,15.8742012 C6.35504121,15.7588717 6.80297453,15.5910331 7.22598973,15.3750217 C7.43081526,15.2708805 7.62673137,15.1546918 7.81552085,15.0264597 C7.99541003,14.9059657 8.16551435,14.7717143 8.32580645,14.6271117 C8.47541773,14.4928471 8.61344767,14.3456843 8.73812943,14.1881705 C8.85389949,14.043579 8.95542086,13.888654 9.03913022,13.7251251 C9.12106135,13.5659015 9.19586584,13.4015045 9.26265688,13.2353978 C9.3258846,13.0770356 9.38109885,12.9160956 9.42651685,12.7517075 C9.47015433,12.5959276 9.50399326,12.4375611 9.5271491,12.2774914 C9.54941126,12.1234323 9.56099031,11.9685227 9.56099031,11.8127274 C9.56187943,11.486529 9.50577606,11.1620711 9.39534983,10.8522211 C9.33568314,10.6904152 9.26355056,10.5337783 9.1762756,10.38402 C9.08187858,10.2204934 8.97412198,10.0638586 8.85389037,9.91753752 C8.71051204,9.741961 8.54753207,9.58274619 8.36854569,9.44072152 C8.18153216,9.29096547 7.97938538,9.16015339 7.76565499,9.04998843 C7.5554879,8.93982346 7.33285948,8.85375598 7.10310216,8.7909245 C6.99445644,8.76080099 6.88313881,8.73842428 6.77093662,8.72293289 C6.66318003,8.70744149 6.55453431,8.70055618 6.44499492,8.69969469 C6.25887051,8.6988354 6.07363978,8.72551515 5.89551972,8.77801537 C5.71741106,8.83223636 5.55088373,8.91572157 5.40215017,9.02416796 C5.29886425,9.09996586 5.16796321,9.13267164 5.03881306,9.11545726 Z" ></path>
                                <path d="M10.3107839,7.38893873 C10.2199479,7.47844776 10.095273,7.52836571 9.96436968,7.52836571 C9.83524004,7.52836571 9.71056056,7.47844776 9.61795545,7.38893873 C9.52711946,7.30115047 9.47457712,7.18065865 9.47457712,7.05500669 C9.47457712,6.92935474 9.52711946,6.8088541 9.61795545,6.72021537 L16.4545924,0.112961501 C16.611328,-0.0376538338 16.8651371,-0.0376538338 17.0218727,0.112961501 L18.8831168,1.91261635 C19.0389611,2.06323168 19.0389611,2.30938648 18.8831168,2.46000402 L12.0366768,9.07673207 C11.9440603,9.16537962 11.8193831,9.21529977 11.6893735,9.21529977 C11.5602438,9.21529977 11.4355643,9.16538182 11.3438483,9.07673207 C11.2512318,8.98808453 11.1995809,8.8675905 11.1995809,8.74194075 C11.1995809,8.616291 11.2512318,8.49578815 11.3438483,8.40714942 L17.4974599,2.46000402 C17.6533042,2.30938869 17.6533042,2.06323389 17.4974599,1.91261635 L17.0219183,1.45217087 C16.8651827,1.30155553 16.6113736,1.30155553 16.454638,1.45217087 L10.3107839,7.38893873 Z" ></path>
                            </g>
                            <g transform="translate(0.000000, 0.000000)">
                                <path d="M2.47404452,1.78643161 C2.7468143,1.78643161 2.97367637,1.97889181 3.02072263,2.23269334 L3.02967458,2.3304882 L3.02967458,5.96830904 C3.02967458,6.2687832 2.78091052,6.51236563 2.47404452,6.51236563 C2.20127473,6.51236563 1.97441267,6.31990544 1.9273664,6.0661039 L1.91841446,5.96830904 L1.91841446,2.3304882 C1.91841446,2.03001404 2.16717851,1.78643161 2.47404452,1.78643161 Z" fill-rule="nonzero"></path>
                                <path d="M4.2662091,3.60534204 C4.57307511,3.60534204 4.82183916,3.84892447 4.82183916,4.14939862 C4.82183916,4.41648676 4.62528485,4.63862341 4.36608431,4.68468972 L4.2662091,4.6934552 L0.555630059,4.6934552 C0.248764051,4.6934552 0,4.44987277 0,4.14939862 C0,3.88231048 0.196554312,3.66017383 0.455754853,3.61410752 L0.555630059,3.60534204 L4.2662091,3.60534204 Z" fill-rule="nonzero"></path>
                                <path d="M9.58530463,5.49133694 C9.85807442,5.49133694 10.0849365,5.68379714 10.1319827,5.93759867 L10.1409347,6.03539353 L10.1409347,9.67321437 C10.1409347,9.97368853 9.89217064,10.217271 9.58530463,10.217271 C9.31253485,10.217271 9.08567278,10.0248108 9.03862652,9.77100923 L9.02967458,9.67321437 L9.02967458,6.03539353 C9.02967458,5.73491937 9.27843863,5.49133694 9.58530463,5.49133694 Z" fill-rule="nonzero"></path>
                                <ellipse cx="4.10938012" cy="11.3524527" rx="1.11126012" ry="1.08811317"></ellipse>
                                <ellipse cx="7.99946107" cy="1.08811317" rx="1.11126012" ry="1.08811317"></ellipse>
                                <path d="M11.3774692,7.31024737 C11.6843352,7.31024737 11.9330993,7.5538298 11.9330993,7.85430395 C11.9330993,8.12139209 11.736545,8.34352874 11.4773444,8.38959505 L11.3774692,8.39836053 L7.66689018,8.39836053 C7.36002417,8.39836053 7.11126012,8.1547781 7.11126012,7.85430395 C7.11126012,7.58721581 7.30781443,7.36507916 7.56701497,7.31901285 L7.66689018,7.31024737 L11.3774692,7.31024737 Z" fill-rule="nonzero"></path>
                            </g>
                        </g>
                    </g>
                </g>
            </svg>
          `;
          if(productData.tags.includes('personalization:true')){
            
            if (!productItem.querySelector('.boost-sd__product-personalise')) {
              var personalize_html = `
                <div class="flex gap-2 items-center boost-sd__product-personalise">
                  ${icon_personalize}
                  <span class="font-brandon uppercase font-bold text-[10px] leading-4 tracking-1/5px text-grey-1">Personalize it</span>
                </div>
              `;
              productItem.querySelector('.boost-sd__product-info').insertAdjacentHTML('beforeend', personalize_html);
            }
          }
        }
      }),
    });
    componentRegistry.useComponentPlugin('ProductSwatchOption', {
      name: 'Customize swatches',
      enabled: true,
      apply: () => ({
        props: (props, element) => {
          if(props.isQuickView){
            var label_element = element.getRootElm();
            if(props.labelAs == 'image'){
              if(label_element){
                var color_value = props.value.toLowerCase().replaceAll(' ', '-').replaceAll(':', '-').replaceAll('/', '-');
                label_element.querySelector('.boost-sd__tooltip').setAttribute('data-color', color_value);
              }
            }
          }
          return props;
        }
      })
    })

    componentRegistry.useComponentPlugin('QuickView', {
      name: 'Customize QuickView',
      enabled: true,
      apply: () => ({
        afterRender(element){
          let props = element.getParams().props;
          if (props.isOpen) {
          let quickViewProductData = props.productData;
          let quickViewElem = element.getRootElm();
          var sku = '';
          quickViewProductData.metafields.length > 0 && quickViewProductData.metafields.forEach(metafield => {
            if (metafield.namespace == 'custom_fields' && metafield.key == 'root_sku') {
              sku = metafield.value;
              return false;
            }
          });
          var sku_html = `<div class="boost-sd__quick-view-sku">#${sku}</div>`;
          quickViewElem.querySelector('.boost-sd__quick-view-price').insertAdjacentHTML('beforebegin', sku_html);
          }
          return props;
        }
      })
    })

  }
}

window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
  (componentRegistry) => {
      componentRegistry.useModulePlugin('CartAPI', {
          name: 'CartAPI plugin',
          apply(builder) {
              builder.on('methodFulfilled', 'addToCart', (payload) => {
                  let itemID = payload.args[0];
                  let itemAddedCount = payload.args[1];
                  let cartTimeout = boostSDData.miniCartTimeout || 5000;

                  let miniCartCount = document.querySelector('[data-minicart-count]');
                  let miniCartText = document.querySelector('[data-minicart-text]');
                  let cartCount = document.querySelector('[data-cart-count]');

                  miniCartCount.textContent = itemAddedCount;
                  miniCartText.textContent = itemAddedCount == 1 ? 'item' : 'items';

                  fetch(window.Shopify.routes.root + 'cart.js')
                  .then(response => response.clone().json().then(data => {
                    let cartItems = data.items;
                    cartCount.textContent = data.item_count;
                    cartCount.classList.remove('hidden');
                    let item = cartItems.find(item => item.id == itemID);


                    let itemImage = document.createElement('img');
                    itemImage.src = item.image;
                    itemImage.classList.add('w-full', 'h-auto');

                    let miniCartImage = document.querySelector('[data-minicart-image]');
                    miniCartImage.innerHTML = itemImage.outerHTML;

                    let miniCartTitle = document.querySelector('[data-minicart-title]');
                    miniCartTitle.textContent = item.product_title;

                    let miniCartSku = document.querySelector('[data-minicart-sku]');
                    let itemSku = item.sku.split(' ')[0];
                    miniCartSku.textContent = "#" + itemSku;

                    let miniCartOptions = document.querySelector('[data-minicart-options]');
                    miniCartOptions.innerHTML = '';

                    item.options_with_values.forEach(option => {
                      let optionElement = document.createElement('div');
                      optionElement.classList.add('font-roboto', 'uppercase', 'text-xs', 'font-normal');
                      optionElement.textContent = `${option.name}: ${option.value}`;
                      console.log(option.value);
                      if(option.value != 'Default Title'){
                        miniCartOptions.appendChild(optionElement);
                      }
                    });

                    let variantId = item.variant_id;
                    
                    fetch(window.Shopify.routes.root + 'products/' + item.handle + '.js')
                    .then(response => response.json())
                    .then(product => {
                      let variant = product.variants.find(variant => variant.id == variantId);
                      let variantPrice = variant.price;
                      variantPrice = (variantPrice / 100).toFixed(2);
                      let variantCompareAtPrice = variant.compare_at_price;
                      variantCompareAtPrice = (variantCompareAtPrice / 100).toFixed(2);
                      let variantPriceElement = document.querySelector('[data-minicart-price]');
                      if (variantCompareAtPrice > variantPrice) {
                        variantPriceElement.innerHTML = '<div class="font-roboto text-xs font-medium text-[#9E292B] leading-6">$' + variantPrice + '</div> <div class="line-through font-roboto text-xs font-medium leading-6">$' + variantCompareAtPrice + '</div>';
                      } else {
                        variantPriceElement.innerHTML = '<div class="font-roboto text-xs font-medium leading-6">$' + variantPrice + '</div>';
                      }
                    });

                    let siteNav = document.querySelector('[data-site-nav]');
                    siteNav.classList.remove('inactive');
                    let miniCart = document.querySelector('[data-minicart]');
                    miniCart.classList.remove('hidden');
                    setTimeout(() => {
                      miniCart.classList.add('hidden');
                    }, cartTimeout);

                    return data;
                  }));

                  return payload;
              });
          }
      });
  }
]);


window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([customize.updateProductItem]);
window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([customize.addDescription]);
window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([customize.addSEO]);

window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
  (componentRegistry) => {
      componentRegistry.useModulePlugin('FilterAPI', {
          name: 'FilterAPI plugin',
          apply(builder) {
              builder.on('methodFulfilled', 'get', (payload) => {
                  let headerTitle = document.querySelector('.boost-sd__header-title');
                  let filterText = "";
                  if (payload.args[0].pf_pt_type) {
                    let typeText = "Type: ";
                    payload.args[0].pf_pt_type.forEach((type, index, array) => {
                      if (index === array.length - 1) {
                        typeText += type + "<br>";
                      } else {
                        typeText += type + ", ";
                      }

                    }
                    );
                    filterText += typeText;
                  }

                  if (payload.args[0].pf_opt_color) {
                    let colorText = "Color: ";
                    payload.args[0].pf_opt_color.forEach((color, index, array) => {
                      if (index === array.length - 1) {
                        colorText += color + "<br>";
                      } else {
                        colorText += color + ", ";
                      }
                    });
                    filterText += colorText;
                  }

                  if (payload.args[0].pf_opt_size) {
                    let sizeText = "Size: ";
                    payload.args[0].pf_opt_size.forEach((size, index, array) => {
                      if (index === array.length - 1) {
                        sizeText += size + "<br>";
                      } else {
                        sizeText += size + ", ";
                      }
                    });
                    filterText += sizeText;
                  }

                  if (payload.args[0].pf_p_price) {
                    let priceText = "Price: ";
                    let priceRangeArray = payload.args[0].pf_p_price[0].split(':');
                    let minPrice = priceRangeArray[0];
                    let maxPrice = priceRangeArray[1];
                    priceText += "$" + minPrice + " - $" + maxPrice + "<br>";
                    filterText += priceText;
                  }

                  if (payload.args[0].pf_r_review_ratings) {
                    let ratingText = "Rating: ";
                    payload.args[0].pf_r_review_ratings.forEach((rating, index, array) => {
                      if (index === array.length - 1) {
                        ratingText += rating + " stars<br>";
                      } else {
                        ratingText += rating + " stars, ";
                      }
                    });
                    filterText += ratingText;
                  }

                  let filterSpan = document.querySelector('[data-header-filters]');
                  if (filterSpan) {
                    filterSpan.remove();
                  }

                  if (filterText != "") {
                    headerTitle.innerHTML.replace(/<br>/g, '');
                    filterText = "<span data-header-filters><br>" + filterText + "</span>";
                    headerTitle.innerHTML += filterText;
                  }
                  
                  return payload;
              });
          }
      });
  }
]);

